import { tw } from "~/utils";

type SliderArrowButtonProps = {
  onClick: () => void;
  children: React.ReactNode;
  ariaLabel: string;
  variant?: "primary" | "secondary";
  disabled?: boolean;
};

export const SliderArrowButton = ({
  onClick,
  children,
  ariaLabel,
  variant = "primary",
  disabled,
}: SliderArrowButtonProps) => {
  const baseClasses =
    "flex size-10 items-center justify-center rounded-full border transition-colors cursor-pointer outline-none focus-visible:ring-2 focus-visible:ring-violet focus-visible:ring-offset-2 disabled:bg-transparent";

  const variantClasses = {
    primary:
      "border-violet text-violet hover:bg-neutral-100/50 disabled:border-gray-300 disabled:text-gray-300",
    secondary:
      "border-gray-600 text-gray-600 hover:bg-neutral-100/50 disabled:border-gray-300 disabled:text-gray-300",
  };

  return (
    <button
      onClick={onClick}
      aria-label={ariaLabel}
      className={tw(baseClasses, variantClasses[variant])}
      disabled={disabled}
    >
      {children}
    </button>
  );
};
